module.exports = __webpack_public_path__ + "img/cards.2dfae4e6.png";